jQuery(document).ready(function () {
  jQuery('.select-options-rice li').click(function () {
    var currentCtegoryClass = $(this).attr('class')

    jQuery(
      '.grid__item.grid__item--collection-template.small--one-half.medium-up--one-quarter'
    ).each(function () {
      if (jQuery(this).hasClass(currentCtegoryClass)) {
        jQuery(this).show()
      } else {
        jQuery(this).hide()
      }
    })

    if (currentCtegoryClass == 'all-recipe') {
      jQuery(
        '.grid__item.grid__item--collection-template.small--one-half.medium-up--one-quarter'
      ).each(function () {
        jQuery(this).show()
      })
    }
  })
})

jQuery(document).ready(function () {
  jQuery('.select-options li').click(function () {
    var currentCtegoryClass = $(this).attr('class')

    jQuery(
      '.grid__item.grid__item--collection-template.small--one-half.medium-up--one-quarter'
    ).each(function () {
      if (jQuery(this).hasClass(currentCtegoryClass)) {
        jQuery(this).show()
      } else {
        jQuery(this).hide()
      }
    })

    if (currentCtegoryClass == 'all-events') {
      jQuery(
        '.grid__item.grid__item--collection-template.small--one-half.medium-up--one-quarter'
      ).each(function () {
        jQuery(this).show()
      })
    }
  })
})

$(document).ready(function () {
  $('#sitemin_header_icon').click(function () {
    $('#mini-cart-items').slideDown()
    $('body').toggleClass('menu-open')
  })
})

$('.minicart-close').click(function () {
  $('body').removeClass('menu-open')
  $('#mini-cart-items').slideUp()
})

$(window).scroll(function () {
  if (
    $(window).scrollTop() >=
    $(document).height() - $(window).height() - $('#events').innerHeight()
  ) {
    $('.popup-overlay, .popup-content').addClass('active')
    //check to see if the submited cookie is set, if not check if the popup has been closed, if not then display the popup

    if (getCookie('popupCookie') != 'submited') {
      if (getCookie('popupCookie') != 'closed') {
        $('body.template-index').addClass('popup-open')
        $('.popup-overlay').css('display', 'block')
      }
    }

    $('.closer').click(function () {
      $('.popup-overlay').css('display', 'none')
      $('body.template-index').removeClass('popup-open')
      /*$('.custom-overlay').css('display','none');*/

      setCookie('popupCookie', 'closed', 0.00069444444)
    })

    function getCookie(cname) {
      var name = cname + '='
      var ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    }

    function setCookie(cname, cvalue, exdays) {
      var d = new Date()
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      var expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    }
  }
})

$(document).ready(function () {
  $('.scappfancybox-wrap').addClass('active')
  //check to see if the submited cookie is set, if not check if the popup has been closed, if not then display the popup

  if (getCookie('popupCookies') != 'submited') {
    if (getCookie('popupCookies') != 'closed') {
      setTimeout(function () {
        // $('body.template-index').addClass('popup-open');
        $('.scappfancybox-wrap').css('display', 'block')
      }, 2000)
    }
  }

  $('.close-free-popup').click(function () {
    $('.scappfancybox-wrap').css('display', 'none')
    $('body.template-index').removeClass('popup-open')
    /*$('.custom-overlay').css('display','none');*/

    setCookie('popupCookies', 'closed', 0.31536)
  })

  $('.product-no').click(function () {
    $('.scappfancybox-wrap').css('display', 'none')
    $('body.template-index').removeClass('popup-open')
    /*$('.custom-overlay').css('display','none');*/

    setCookie('popupCookies', 'closed', 0.31536)
  })

  function getCookie(pname) {
    var name = pname + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) == ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }

  function setCookie(pname, pvalue, pexdays) {
    var d = new Date()
    d.setTime(d.getTime() + pexdays * 24 * 60 * 60 * 1000)
    var expires = 'expires=' + d.toUTCString()
    document.cookie = pname + '=' + pvalue + ';' + expires + ';path=/'
  }
})

$(document).ready(function () {
  var isNZMarket = $('body').data('country') === 'NZ';
  if (isNZMarket && window.location.href.indexOf('manuka-honey') > -1) {
    $('.template-page').addClass('manuka-honey');
  }
})
$(document).ready(function () {
  if (window.location.href.indexOf('fruit-n-honey') > -1) {
    $('.template-page').addClass('fruit-n-honey')
  }
})
$(document).ready(function () {
  if (window.location.href.indexOf('account') > -1) {
    $('.site-header__account').addClass('account')
  }
})

$(document).ready(function () {
  if (window.location.href.indexOf('events-n-honey') > -1) {
    $('.template-product').addClass('events-n-honey-single')
  }
})

$(document).ready(function () {
  if (window.location.href.indexOf('collections/all-products/products') > -1) {
    $('.template-product').addClass('custom-products')
  }
})

$(document).ready(function () {
  if (window.location.href.indexOf('all-products') > -1) {
    $('.template-collection').addClass('allproducts')
  }
})

$(document).ready(function () {
  if (window.location.href.indexOf('sample') > -1) {
    $('.template-page').addClass('sample')
  }
})

$(document).ready(function () {
  if (window.location.href.indexOf('recipes-n-honey') > -1) {
    $('.template-collection').addClass('recipes-n-honey')
  }
  if (window.location.href.indexOf('/blogs/recipes') > -1) {
    $('.template-blog').addClass('recipes-n-honey')
  }
})

$(document).ready(function () {
  if (window.location.href.indexOf('related-interests') > -1) {
    $('.template-collection').addClass('recipes-n-honey')
  }
})

$(document).ready(function () {
  if (window.location.href.indexOf('events-n-honey') > -1) {
    $('.template-collection').addClass('events-n-honey')
  }
  if (window.location.href.indexOf('/blogs/events') > -1) {
    $('.template-blog').addClass('events-n-honey')
  }
})

$(document).ready(function () {
  if (window.location.href.indexOf('our-story') > -1) {
    $('.template-page').addClass('ourstory')
  }
})

$(document).ready(function () {
  if (window.location.href.indexOf('fruit-n-honey/products') > -1) {
    $('.template-product').addClass('fruit-products')
  }
})

$(document).ready(function () {
  if (window.location.href.indexOf('manuka-honey/products') > -1) {
    $('.template-product').addClass('manuka-products')
  }
})

$(document).ready(function () {
  if (
    window.location.href.indexOf('allproducts') > -1 ||
    window.location.href.indexOf('best-selling-products') > -1 ||
    window.location.href.indexOf('flowers-n-honey') > -1 ||
    window.location.href.indexOf('fruit-n-honey') > -1 ||
    window.location.href.indexOf('frontpage') > -1 ||
    window.location.href.indexOf('kids-n-honey') > -1 ||
    window.location.href.indexOf('manuka-honey') > -1 ||
    window.location.href.indexOf('natives-n-honey') > -1 ||
    window.location.href.indexOf('newest-products') > -1 ||
    window.location.href.indexOf('others-n-honey') > -1 ||
    window.location.href.indexOf('skipcart-best-selling-products') > -1
  ) {
    $('.template-collection').addClass('allproducts')
  }
})
$(document).ready(function () {
  if (window.location.href.indexOf('products') > -1) {
    $('.template-product').addClass('custom-products')
  }
  if (window.location.href.indexOf('events-n-honey/products') > -1) {
    $('.template-product').removeClass('custom-products')
  }
  if (window.location.href.indexOf('recipes-n-honey/products') > -1) {
    $('.template-product').removeClass('custom-products')
  }
})
$(document).ready(function () {
  $('.free-product-popup').click(function () {
    $('#free_popup').css('display', 'block')
    $('body.template-index').addClass('popup-open')
  })
  $('.close-free-popup').click(function () {
    $('#free_popup').css('display', 'none')
    $('body.template-index').removeClass('popup-open')
  })
})

$(document).ready(function () {
  if (
    window.location.href.indexOf('collections/recipes-n-honey/products') > -1
  ) {
    $('.template-product').addClass('recipes-single-page')
  }
})

$(document).ready(function () {
  $('#navi li a').click(function () {
    $('li a').removeClass('active')
    $(this).addClass('active')
  })
})

$(document).ready(function () {
  $('#nav li')
    .find('active')
    .css({ color: 'red !important', border: '2px solid red' })
})

$('button.printPage').click(function () {
  window.print()
  return false
})
$(document).ready(function () {
  if ($('body').hasClass('non-purchasable-products')) {
      return; // stop here
  }
  $('ul.mobile-tabs a').next().hide()
  $('ul.mobile-tabs #mob-tab-1').show()
  $('ul.mobile-tabs a').click(function (e) {
    $('ul.mobile-tabs a').removeClass('active')
    $('ul.mobile-tabs a').next().hide()
    $(this).next().show()
    $(this).addClass('active')
  })
})
$(document).ready(function () {
  $('ul.tabs').each(function () {
    var active,
      content,
      links = $(this).find('a')
    active = links.first().addClass('active')
    content = $(active.attr('href'))
    links.not(':first').each(function () {
      $($(this).attr('href')).hide()
    })
    $(this)
      .find('a')
      .click(function (e) {
        active.removeClass('active')
        content.hide()
        active = $(this)
        content = $($(this).attr('href'))
        active.addClass('active')
        content.show()
        return false
      })
  })
})

function TextBox_AddToIntValue(targetId, addToValue) {
  var input = document.getElementById(targetId)
  var textInt = parseInt(input.value, 10)
  if (isNaN(textInt) || textInt < 1) {
    textInt = 1
  }
  var newValue = textInt + addToValue
  if (newValue < 1) {
    newValue = 1
  }
  input.value = newValue
}

$('.cart-qty-sec').on('click', function () {
  var $button = $(this)
  var oldValue = $button
    .closest('.sp-quantity')
    .find('input.cart__qty-input')
    .val()

  if ($button.text() == '+') {
    var newVal = parseFloat(oldValue) + 1
  } else {
    // Don't allow decrementing below zero
    if (oldValue > 0) {
      var newVal = parseFloat(oldValue) - 1
    } else {
      newVal = 0
    }
  }

  $button.closest('.sp-quantity').find('input.cart__qty-input').val(newVal)
})
$(document).ready(function () {
  $(document).on('click', '.cart__remove a.text-link', function (event) {
    event.preventDefault()
    var qty = urlParam($(this).attr('href'), 'quantity')
    var line = urlParam($(this).attr('href'), 'line')
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      type: 'post',
      data: { line: line, quantity: qty },
      success: function (itemData) {
        $.getJSON('/cart.js', function (cart) {
          if (cart.item_count != 0) {
            var cartObj = ''
            cartObj +=
              '<tr class="cartItemHeader"><th colspan="2">Product</th><th>Price</th><th>Qty</th><th>Total</th></tr>'
            $.each(cart.items, function (index, value) {
              var image = ''
              if (value['featured_image']['url'] == null) {
                image =
                  'https://cdn.shopify.com/s/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_95x95@2x.gif'
              } else {
                image = value['featured_image']['url']
              }
              var remove = index + 1
              cartObj +=
                '<tr class="cart__row border-bottom line' +
                index +
                '"><td class="cart__image-wrapper"><div><img class="cart__image" src="' +
                image +
                '" alt="' +
                value['product_title'] +
                '" data-item-url="' +
                value['url'] +
                '"></div></td><td class="cart__meta small--text-left"><div class="list-view-item__title"><a href="' +
                value['url'] +
                '" class="cart__product-title"><span id="product-name-' +
                value['variant_id'] +
                '"></span></a><ul class="item-option-' +
                value['variant_id'] +
                '"></ul></div></td><td class="cart__price-wrapper text-right"><span id="item-price-' +
                value['variant_id'] +
                '"></span></td><td class="text-right small--hide"><div class="cart__qty"><span class="mobile-qty">Qty:</span><label for="updates_large_' +
                value['key'] +
                '" class="cart__qty-label">Quantity</label><input class="cart__qty-input" type="number" name="updates[]" id="updates_large_' +
                value['key'] +
                '" value="' +
                value['quantity'] +
                '" min="0" pattern="[0-9]*" data-quantity-item="' +
                index +
                '"></div><p class="cart__remove small--hide"><a href="/cart/change?line=' +
                remove +
                '&amp;quantity=0" class="text-link text-link--accent" aria-label="Remove' +
                value['product_title'] +
                '">Remove</a></p></td><td class="text-right small--hide price"><span id="item-total-' +
                value['variant_id'] +
                '"></span></td></tr>'
            })
            cartObj +=
              '<tr class="cart__update-wrapper"><td colspan="4" class="text-right sub-total"><span class="cart-subtotal__title">Subtotal</span></td><td><span class="cart-subtotal__price"></span></td></tr>'
            $('#mini-cart-items table').html(cartObj)
            $.each(cart.items, function (index, value) {
              $(
                '.cart__product-title #product-name-' + value['variant_id']
              ).text(value['product_title'])
              $('#item-price-' + value['variant_id']).text(
                Shopify.formatMoney(value['final_price'])
              )
              $('#item-total-' + value['variant_id']).text(
                Shopify.formatMoney(value['final_line_price'])
              )
              $('.cart-subtotal__price').text(
                Shopify.formatMoney(cart.total_price)
              )
              $.each(value['options_with_values'], function (index, val) {
                $('.item-option-' + value['variant_id']).html(
                  '<li>' + val['name'] + ':' + val['value'] + '</li>'
                )
              })
            })
            var value = $('#CartCount').html() || '0'
            $('#CartCount .cart-item').html(cart.item_count)
            $('#CartCount .total-price').html(
              Shopify.formatMoney(cart.total_price)
            )
            if (cart.item_count > 1) {
              $('.total-cart-item #total_count').text(
                '(' + cart.item_count + ' items)'
              )
            } else {
              $('.total-cart-item #total_count').text(
                '(' + cart.item_count + ' item)'
              )
            }

            if (screen.width > 767) {
              $('.custom-mini-link.desktop').show()
              $('.total-cart-item').show()
            }
          } else {
            var value = $('#CartCount').html() || '0'
            var removeObj = ''
            $('#CartCount .cart-item').html(cart.item_count)
            $('#CartCount .total-price').html(
              Shopify.formatMoney(cart.total_price)
            )
            removeObj += '<tr><td>There Have No Items In Your Cart</td></tr>'
            $('#mini-cart-items table').html(removeObj)
            $('.custom-mini-link.desktop').hide()
            $('.total-cart-item').hide()
            $('.custom-mini-link.mobile').hide()
          }
        })
      },
    })
  })
})
function urlParam(url, name) {
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(url)
  return results[1] || 0
}
$(document).ready(function () {
  $.getJSON('/cart.js', function (cart) {
    if (cart.item_count == 0) {
      $('.custom-mini-link.desktop').hide()
      $('.total-cart-item').hide()
      $('.custom-mini-link.mobile').hide()
    }
  })
})

$(document).ready(function () {
  $.noConflict()
  $('.owl-carousel').owlCarousel({
    margin: 10,
    center: true,
    loop: true,
    autoWidth: true,
    items: 5,
    pagination: false,
    navigation: true,
    navigationText: [
      "<span class='angle-left'><span class='prv'><span>PREV</span><img src='https://cdn.shopify.com/s/files/1/0088/3707/0903/t/1/assets/left-white-honey.png' class='btn-hover'></span></span>",
      "<span class='angle-right'><span class='nxt'><span>NEXT</span><img src='https://cdn.shopify.com/s/files/1/0088/3707/0903/t/1/assets/right-white-honey.png' class='btn-hover'></span></span>",
    ],
  })
})

if ($(window).width() > 991) {
  new WOW().init()
}
$(document).ready(function () {
  $('.btn-hover').hover(function () {
    $(this).removeClass('animated')
    $(this).toggleClass('wow fadeIntada animated')
  })
})
$(document).ready(function () {
  $('.nxt span').hover(function () {
    $('.btn-hover').removeClass('animated')
    $('.btn-hover').toggleClass('wow fadeIntada animated')
  })
})
$('#ProductSelect-product-template').each(function () {
  var $this = $(this),
    numberOfOptions = $(this).children('option').length

  $this.addClass('select-hidden')
  $this.wrap('<div class="select"></div>')
  $this.after('<div class="select-styled"></div>')

  var $styledSelect = $this.next('div.select-styled')
  $styledSelect.text($this.children('option').eq(0).text())

  var $list = $('<ul />', {
    class: 'select-options',
    id: 'rmenu',
  }).insertAfter($styledSelect)

  for (var i = 0; i < numberOfOptions; i++) {
    $('<li />', {
      text: $this.children('option').eq(i).text(),
      rel: $this.children('option').eq(i).val(),
      class: $this.children('option').eq(i).attr('class'),
    }).appendTo($list)
  }

  var $listItems = $list.children('li')

  $styledSelect.click(function (e) {
    e.stopPropagation()
    $('div.select-styled.active')
      .not(this)
      .each(function () {
        $(this).removeClass('active').next('ul.select-options').hide()
      })
    $(this).toggleClass('active').next('ul.select-options').toggle()
  })

  $listItems.click(function (e) {
    e.stopPropagation()
    $styledSelect.text($(this).text()).removeClass('active')
    $this.val($(this).attr('rel'))
    $list.hide()
    //console.log($this.val());
  })

  $(document).click(function () {
    $styledSelect.removeClass('active')
    $list.hide()
  })
})

$(document).ready(function () {
  $('#rmenu > li').click(function () {
    var page = $(this).attr('class')
    if (page) {
      $('.product__price').html(
        '<span class="from_price">From</span> <b><span class="price-item price-item--regular">' +
          page +
          '</span></b>'
      )
    } else {
      var page = $('.price-item.price-item--regular').attr('class')
    }
  })
})

$(document).ready(function () {
  $('.select').insertAfter($('#SingleOptionSelector-0'))
})

$('#recipe_products').each(function () {
  var $this = $(this),
    numberOfOptions = $(this).children('option').length

  $this.addClass('select-hidden')
  $this.wrap('<div class="select"></div>')
  $this.after('<div class="select-styled"></div>')

  var $styledSelect = $this.next('div.select-styled')
  $styledSelect.text($this.children('option').eq(0).text())

  var $list = $('<ul />', {
    class: 'select-options-rice',
  }).insertAfter($styledSelect)

  for (var i = 0; i < numberOfOptions; i++) {
    $('<li />', {
      text: $this.children('option').eq(i).text(),
      class: $this.children('option').eq(i).val(),
    }).appendTo($list)
  }

  var $listItems = $list.children('li')

  $styledSelect.click(function (e) {
    e.stopPropagation()
    $('div.select-styled.active')
      .not(this)
      .each(function () {
        $(this).removeClass('active').next('ul.select-options-rice').hide()
      })
    $(this).toggleClass('active').next('ul.select-options-rice').toggle()
  })

  $listItems.click(function (e) {
    e.stopPropagation()
    $styledSelect.text($(this).text()).removeClass('active')
    $this.val($(this).attr('rel'))
    $list.hide()
    //console.log($this.val());
  })

  $(document).click(function () {
    $styledSelect.removeClass('active')
    $list.hide()
  })
})

$('#reci_products').each(function () {
  var $this = $(this),
    numberOfOptions = $(this).children('option').length

  $this.addClass('select-hidden')
  $this.wrap('<div class="select"></div>')
  $this.after('<div class="select-styled"></div>')

  var $styledSelect = $this.next('div.select-styled')
  $styledSelect.text($this.children('option').eq(0).text())

  var $list = $('<ul />', {
    class: 'select-options-rice',
  }).insertAfter($styledSelect)

  for (var i = 0; i < numberOfOptions; i++) {
    $('<li />', {
      text: $this.children('option').eq(i).text(),
      class: $this.children('option').eq(i).val(),
    }).appendTo($list)
  }

  var $listItems = $list.children('li')

  $styledSelect.click(function (e) {
    e.stopPropagation()
    $('div.select-styled.active')
      .not(this)
      .each(function () {
        $(this).removeClass('active').next('ul.select-options-rice').hide()
      })
    $(this).toggleClass('active').next('ul.select-options-rice').toggle()
  })

  $listItems.click(function (e) {
    e.stopPropagation()
    $styledSelect.text($(this).text()).removeClass('active')
    $this.val($(this).attr('rel'))
    $list.hide()
    //console.log($this.val());
  })

  $(document).click(function () {
    $styledSelect.removeClass('active')
    $list.hide()
  })
})

$('#events_products').each(function () {
  var $this = $(this),
    numberOfOptions = $(this).children('option').length

  $this.addClass('select-hidden')
  $this.wrap('<div class="select"></div>')
  $this.after('<div class="select-styled"></div>')

  var $styledSelect = $this.next('div.select-styled')
  $styledSelect.text($this.children('option').eq(0).text())

  var $list = $('<ul />', {
    class: 'select-options',
  }).insertAfter($styledSelect)

  for (var i = 0; i < numberOfOptions; i++) {
    $('<li />', {
      text: $this.children('option').eq(i).text(),
      class: $this.children('option').eq(i).val(),
    }).appendTo($list)
  }

  var $listItems = $list.children('li')

  $styledSelect.click(function (e) {
    e.stopPropagation()
    $('div.select-styled.active')
      .not(this)
      .each(function () {
        $(this).removeClass('active').next('ul.select-options').hide()
      })
    $(this).toggleClass('active').next('ul.select-options').toggle()
  })

  $listItems.click(function (e) {
    e.stopPropagation()
    $styledSelect.text($(this).text()).removeClass('active')
    $this.val($(this).attr('rel'))
    $list.hide()
    //console.log($this.val());
  })

  $(document).click(function () {
    $styledSelect.removeClass('active')
    $list.hide()
  })
})

$('#dynamic_select').each(function () {
  var $this = $(this),
    numberOfOptions = $(this).children('option').length

  $this.addClass('select-hidden')
  $this.wrap('<div class="select"></div>')
  $this.after('<div class="select-styled"></div>')

  var $styledSelect = $this.next('div.select-styled')
  $styledSelect.text($this.children('option').eq(0).text())

  var $list = $('<ul />', {
    class: 'select-options-product',
  }).insertAfter($styledSelect)

  for (var i = 0; i < numberOfOptions; i++) {
    $('<li />', {
      text: $this.children('option').eq(i).text(),
      'data-collection': $this.children('option').eq(i).text(),
      class: $this.children('option').eq(i).val(),
    }).appendTo($list)
  }

  var $listItems = $list.children('li')

  $styledSelect.click(function (e) {
    e.stopPropagation()
    $('div.select-styled.active')
      .not(this)
      .each(function () {
        $(this).removeClass('active').next('ul.select-options-product').hide()
      })
    $(this).toggleClass('active').next('ul.select-options-product').toggle()
  })

  $listItems.click(function (e) {
    e.stopPropagation()
    $styledSelect.text($(this).text()).removeClass('active')
    $this.val($(this).attr('rel'))
    $list.hide()
    //console.log($this.val());
  })

  $(document).click(function () {
    $styledSelect.removeClass('active')
    $list.hide()
  })
})

$('.page-width#Collection').show()
$('.product-template__container.page-width').show()

$(document).ready(function () {
  $('.template-index .fruit').click(function (e) {
    e.preventDefault()
    $('html, body').animate(
      {
        scrollTop: $('#fruit-honey').offset().top,
      },
      1500,
      'linear'
    )
  })
})

$(document).ready(function () {
  $('.template-index .flower').click(function (e) {
    e.preventDefault()
    $('html, body').animate(
      {
        scrollTop: $('#flowers-honey').offset().top,
      },
      1500,
      'linear'
    )
  })
})

$(document).ready(function () {
  $('.template-index .menuka').click(function (e) {
    e.preventDefault()
    $('html, body').animate(
      {
        scrollTop: $('#manuka-honey').offset().top,
      },
      1500,
      'linear'
    )
  })
})

$(document).ready(function () {
  $('.template-index .native').click(function (e) {
    e.preventDefault()
    $('html, body').animate(
      {
        scrollTop: $('#native-honey').offset().top,
      },
      1500,
      'linear'
    )
  })
})

$(document).ready(function () {
  $('.template-index .kids').click(function (e) {
    e.preventDefault()
    $('html, body').animate(
      {
        scrollTop: $('#kids-honey').offset().top,
      },
      1500,
      'linear'
    )
  })
})

$(document).ready(function () {
  $('.template-index .other').click(function (e) {
    e.preventDefault()
    $('html, body').animate(
      {
        scrollTop: $('#others-honey').offset().top,
      },
      1500,
      'linear'
    )
  })
})

$(document).ready(function () {
  $('.template-index .recipe').click(function (e) {
    e.preventDefault()
    $('html, body').animate(
      {
        scrollTop: $('#recipes').offset().top,
      },
      1500,
      'linear'
    )
  })
})

$(document).ready(function () {
  $('.template-index .events').click(function (e) {
    e.preventDefault()
    $('html, body').animate(
      {
        scrollTop: $('#events').offset().top,
      },
      1500,
      'linear'
    )
  })
})

$(document).ready(function () {
  $('#rmenu > li').hover(
    function () {
      $(this).css('font-family', 'OpenSans-Bold')
    },
    function () {
      $(this).css('font-family', 'OpenSans-Regular')
    }
  )

  $('.select-options-rice > li').hover(
    function () {
      $(this).css('font-family', 'OpenSans-Bold')
    },
    function () {
      $(this).css('font-family', 'OpenSans-Regular')
    }
  )

  $('.select-options > li').hover(
    function () {
      $(this).css('font-family', 'OpenSans-Bold')
    },
    function () {
      $(this).css('font-family', 'OpenSans-Regular')
    }
  )

  $('.select-options-product > li').hover(
    function () {
      $(this).css('font-family', 'OpenSans-Bold')
    },
    function () {
      $(this).css('font-family', 'OpenSans-Regular')
    }
  )
})

$(document).ready(function () {
  $('.grid-view-item.product-card .grid-view-item__title').each(function () {
    var colId = $(this).attr('id')
    $(this).mouseover(function () {
      $(this).prev().css('background-color', colId)
    })
    $(this).mouseout(function () {
      $(this).prev().css('background-color', 'white')
    })
  })
})

$(document).ready(function () {
  if (window.location.href.indexOf('pages/our-story') !== -1) {
    const $aboutLink = $('a[href="/pages/our-story#about"]')
    const $beekeepingLink = $('a[href="/pages/our-story#beekeeping"]')

    $aboutLink.on('click', (e) => {
      e.preventDefault()
      $('html, body').animate(
        {
          scrollTop: $('#about').offset().top,
        },
        1000
      )
      window.history.pushState({ page: 'Our Story' }, 'About Us', '#about')
    })

    $beekeepingLink.on('click', (e) => {
      e.preventDefault()
      $('html, body').animate(
        {
          scrollTop: $('#beekeeping').offset().top,
        },
        500
      )
      window.history.pushState(
        { page: 'Our Story' },
        'Bee Keeping',
        '#beekeeping'
      )
    })
  }
})

// quick fix the homepage p tag click issue
let i = 1
const clearP = setInterval(() => {
  $('div.fruit').off('click')
  $('div#events.custom-category.events ').off('click')
  i += 1
  if (i > 20) {
    clearInterval(clearP)
  }
}, 500)

// filter Processor v0.1
function filterSectionProcessor() {
  const $container = $('.grid.grid--uniform.grid--view-items')
  const $pagination = $('.list--inline.pagination')
  const $btnPrev = $('.list--inline.pagination li:nth-child(1)')
  const $btnNext = $('.list--inline.pagination li:nth-child(3)')
  const $txtPagination = $('.list--inline.pagination li:nth-child(2)')
  const containerArray = []
  const NUM_PER_PAGE = 10
  const $cards = $($container.find('li'))
  const $filters = $('.select-options-product li')
  let currentPage = 1

  if ($cards.length > 10) {
    for (let i = 0; i < Math.floor($cards.length / NUM_PER_PAGE + 1); i++) {
      const innerArray = []

      containerArray.push(innerArray)
      for (
        let j = 0;
        j <
        (i === Math.floor($cards.length / NUM_PER_PAGE)
          ? $cards.length % 10
          : 10);
        j++
      ) {
        innerArray.push($cards[i * 10 + j])
      }
    }
    changePagination()
    showPagination()
  }

  function changePagination() {
    $txtPagination.text(`Page ${currentPage} of ${containerArray.length}`)
    showPagination()
  }

  function hidePagination() {
    $pagination.hide()
  }

  function showPagination() {
    $pagination.show()
  }

  function render(current = 1, list = containerArray) {
    $container.empty()
    list[current - 1].forEach(function (item) {
      $container.append(item)
    })
  }

  function initFilter() {
    $filters.click(function () {
      // const url = $(this).attr('class'); // get selected value
      const target = $(this).data('collection')
      if (target.trim() === 'All Products') {
        render()
        currentPage = 1
        changePagination()
      } else {
        const filterList = []
        $cards.each(function () {
          if ($(this).data('collection').trim() === target.trim()) {
            filterList.push($(this))
          }
        })
        render(1, [filterList])
        hidePagination()
      }
    })
  }

  function changeCursor(current = 1) {
    if (current === 1) {
      $btnPrev.css('opacity', '0')
      $btnPrev.css('cursor', 'pointer')
      $btnNext.css('cursor', 'pointer')
    } else if (current === containerArray.length) {
      $btnNext.css('opacity', '0')
      $btnPrev.css('cursor', 'pointer')
      $btnNext.css('cursor', 'pointer')
    } else {
      $btnPrev.css('opacity', '1')
      $btnNext.css('opacity', '1')
      $btnPrev.css('cursor', 'pointer')
      $btnNext.css('cursor', 'pointer')
    }
  }

  $btnPrev.on('click', function () {
    if (currentPage > 1) {
      currentPage -= 1
    }
    changePagination()
    changeCursor(currentPage)
    render(currentPage)
  })
  $btnNext.on('click', function () {
    if (currentPage < containerArray.length) {
      currentPage += 1
    }
    changePagination()
    changeCursor(currentPage)
    render(currentPage)
  })

  initFilter()
  changeCursor()
  render()
}

if (window.location.href.indexOf('all-products') !== -1) {
  filterSectionProcessor()
}
